import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "extra-certs" };
const _hoisted_2 = { class: "extra-certs__title" };
const _hoisted_3 = { class: "extra-certs__hint" };
const _hoisted_4 = {
    key: 0,
    class: "extra-certs__need-email"
};
const _hoisted_5 = {
    key: 1,
    class: "extra-certs__list"
};
const _hoisted_6 = { class: "extra-certs__card-title" };
const _hoisted_7 = { class: "extra-certs__meta" };
const _hoisted_8 = { class: "extra-certs__actions" };
const _hoisted_9 = ["disabled", "onClick"];
const _hoisted_10 = ["disabled", "onClick"];
const _hoisted_11 = ["disabled", "onClick"];
const _hoisted_12 = {
    key: 2,
    class: "small text-success mt-2 mb-0"
};
const _hoisted_13 = {
    key: 3,
    class: "small text-danger mt-2 mb-0"
};
import { computed, reactive, ref, watch } from "vue";
import { apoderadosService } from "@/services/apoderadosService";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ExtraGuardianCertFields',
    props: {
        forEmail: {},
        schoolId: {},
        year: {},
        courseCode: {},
        title: {},
        hint: {},
        needEmail: {},
        inhabilidadesLabel: {},
        antecedentesLabel: {},
        initialDocuments: { default: null }
    },
    setup(__props) {
        const props = __props;
        const extraTarget = computed(() => ({
            for_email: String(props.forEmail || "").trim().toLowerCase(),
            school_id: props.schoolId,
            year: props.year,
            course_code: props.courseCode,
        }));
        const canUpload = computed(() => Boolean(extraTarget.value.for_email.includes("@") &&
            extraTarget.value.school_id &&
            extraTarget.value.year &&
            extraTarget.value.course_code));
        const documentTypes = computed(() => [
            { type: "INHABILITIES_CERTIFICATE", label: props.inhabilidadesLabel },
            { type: "ANTECEDENTS_CERTIFICATE", label: props.antecedentesLabel },
        ]);
        const docs = reactive({
            INHABILITIES_CERTIFICATE: null,
            ANTECEDENTS_CERTIFICATE: null,
        });
        const messages = reactive({});
        const errors = reactive({});
        const busy = ref(false);
        const pendingType = ref(null);
        const fileInput = ref(null);
        const applyInitial = () => {
            docs.INHABILITIES_CERTIFICATE =
                props.initialDocuments?.INHABILITIES_CERTIFICATE || null;
            docs.ANTECEDENTS_CERTIFICATE =
                props.initialDocuments?.ANTECEDENTS_CERTIFICATE || null;
        };
        watch(() => [props.forEmail, props.initialDocuments], () => applyInitial(), { immediate: true, deep: true });
        const pick = (type) => {
            pendingType.value = type;
            if (fileInput.value)
                fileInput.value.value = "";
            fileInput.value?.click();
        };
        const onPicked = async (event) => {
            const input = event.target;
            const file = input.files?.[0];
            const type = pendingType.value;
            if (!file || !type)
                return;
            busy.value = true;
            errors[type] = "";
            messages[type] = "";
            try {
                const signed = await apoderadosService.createUserDocumentUpload({
                    type,
                    file_name: file.name,
                    mime_type: file.type || "application/pdf",
                    file_size: file.size,
                    ...extraTarget.value,
                });
                await fetch(signed.upload_url, {
                    method: "PUT",
                    headers: { "Content-Type": signed.mime_type },
                    body: file,
                });
                const completed = await apoderadosService.completeUserDocumentUpload({
                    type,
                    object_key: signed.object_key,
                    original_filename: file.name,
                    mime_type: signed.mime_type,
                    file_size: file.size,
                    ...extraTarget.value,
                });
                docs[type] = completed.document || {
                    originalFilename: file.name,
                };
                messages[type] = completed.message || "Certificado cargado.";
            }
            catch (error) {
                errors[type] =
                    error?.response?.data?.message ||
                        error?.message ||
                        "No se pudo cargar el certificado.";
            }
            finally {
                busy.value = false;
                pendingType.value = null;
            }
        };
        const viewDoc = async (type) => {
            try {
                const result = await apoderadosService.getUserDocument(type, extraTarget.value);
                if (result.view_url)
                    window.open(result.view_url, "_blank");
            }
            catch (error) {
                errors[type] =
                    error?.response?.data?.message || "No se pudo abrir el certificado.";
            }
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("section", _hoisted_1, [
                _createElementVNode("h6", _hoisted_2, _toDisplayString(_ctx.title), 1),
                _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.hint), 1),
                (!canUpload.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.needEmail), 1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(documentTypes.value, (docType) => {
                            return (_openBlock(), _createElementBlock("div", {
                                key: docType.type,
                                class: "extra-certs__card"
                            }, [
                                _createElementVNode("div", _hoisted_6, _toDisplayString(docType.label), 1),
                                (docs[docType.type])
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createElementVNode("div", _hoisted_7, _toDisplayString(docs[docType.type]?.originalFilename), 1),
                                        _createElementVNode("div", _hoisted_8, [
                                            _createElementVNode("button", {
                                                type: "button",
                                                class: "btn btn-outline-primary btn-sm",
                                                disabled: busy.value,
                                                onClick: ($event) => (viewDoc(docType.type))
                                            }, " Ver ", 8, _hoisted_9),
                                            _createElementVNode("button", {
                                                type: "button",
                                                class: "btn btn-outline-secondary btn-sm",
                                                disabled: busy.value,
                                                onClick: ($event) => (pick(docType.type))
                                            }, " Reemplazar ", 8, _hoisted_10)
                                        ])
                                    ], 64))
                                    : (_openBlock(), _createElementBlock("button", {
                                        key: 1,
                                        type: "button",
                                        class: "btn btn-outline-primary btn-sm",
                                        disabled: busy.value,
                                        onClick: ($event) => (pick(docType.type))
                                    }, " Cargar certificado ", 8, _hoisted_11)),
                                (messages[docType.type])
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(messages[docType.type]), 1))
                                    : _createCommentVNode("", true),
                                (errors[docType.type])
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(errors[docType.type]), 1))
                                    : _createCommentVNode("", true)
                            ]));
                        }), 128))
                    ])),
                _createElementVNode("input", {
                    ref_key: "fileInput",
                    ref: fileInput,
                    type: "file",
                    class: "d-none",
                    accept: "application/pdf,.pdf,image/jpeg,.jpg,.jpeg,image/png,.png",
                    onChange: onPicked
                }, null, 544)
            ]));
        };
    }
});
